// extracted by mini-css-extract-plugin
module.exports = {"pageNotFoundWrapper":"_1qcJf"};